/**
 * Badge-location parsing — the mirror of the backend's site/site_utils.py. Both sides read the
 * same `custom:AMZN_LOC_DESCR` claim, so they must agree on the code or the UI's site picker and
 * the server's membership check disagree about where the user works.
 *
 * The claim is a free-form display string from the badge system, so its shape varies per site:
 *
 *     GYR1 - FC (Goodyear,AZ,US)      code, spaced dash, building type, city/state/country
 *     PHX3 - Phoenix, AZ              city/state instead of a building type, no parens
 *     AZA9-SC (Glendale, AZ, US)      no spaces around the dash
 *     SAZ4-SSD-FC(Mesa,AZ,US)         more than one dash
 *     AUS13-CO(Austin,TX-Domaine8)    a dash inside the trailing detail
 *     -                               no location on the badge record
 *
 * So the code is whatever precedes the FIRST dash, trimmed. The trim is the point: the
 * spaced-dash form is the most common one here, and leaving the trailing space in produced a
 * "GYR1 " that matched no entry in the site list, so the new-session site picker never
 * preselected the user's own site.
 */

/** The site code in a badge location descriptor, upper-cased, or '' when it holds none. */
export const parseBadgeSiteCode = (locDescr: string): string =>
  locDescr.split('-')[0].trim().toUpperCase();
